import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwtDecode from 'jwt-decode';
import { MessageService } from 'primeng/api';
import { Subscription, first } from 'rxjs';
import { AppConfig } from 'src/app/models/appconfig';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ConfigService } from 'src/app/services/app.config.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-vendor-reg-forgot-password',
  templateUrl: './vendor-reg-forgot-password.component.html',
  styleUrls: ['./vendor-reg-forgot-password.component.scss']
})
export class VendorRegForgotPasswordComponent implements OnInit {

  public onAuthForm: FormGroup;
  valCheck: string[] = ['remember'];

  password: string;

  config: AppConfig;
  userData: any;
  subscription: Subscription;
  display: any;
  validationOTP: any;
  showPasswordsSections: boolean = false;
  disableUserName: boolean = false;
  submitted: boolean = false;

  constructor(
    private _formBuilder: FormBuilder, 
    public configService: ConfigService, 
    private authService: AuthenticationService, 
    public router: Router, 
    private service: MessageService, 
    private cryptoJs: CryptoJsService,
    private cryptoJsService: CryptoJsService,
    private loader: AppLoaderService,
    private activityRecordService: ActivityRecordService, 
  ) { }

  ngOnInit(): void {
    this.onAuthForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      reEnteredPassword: ['', [Validators.required, Validators.minLength(8)]],
      otp: ['', [Validators.required]],
      emailOtp: ['', [Validators.required]],
    });

    this.config = this.configService.config;
    this.subscription = this.configService.configUpdate$.subscribe(config => {
      this.config = config;
    });
  }

  changePassword() {
    this.submitted = true;
    if (this.onAuthForm.status === "INVALID") {
      return;
    }
    if (this.f.password.value !== this.f.reEnteredPassword.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Password Doesnt Match with Re-Enter Password.' });
      return;
    }
    let reqBody = {
      "Email": this.f.email.value,
      "passWord": this.cryptoJs.Encrypt(this.f.password.value),
      "otp": this.cryptoJs.Encrypt(this.f.otp.value),
      "otpEmail": this.cryptoJs.Encrypt(this.f.emailOtp.value),
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJs.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.authService.forgotPasswordVendorReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.activityRecordService.activityRecord(this.f.email.value, 'vendfor-forgot-pass(success)', '', new Date(), data, reqBodyAfterEncypt);

          if (data === 'Invalid OTP!..') {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Invalid OTP' });
            return;
          }
          else if (data === 'Password Update Failed!.') {
            this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Password Update Failed' });
            return;
          }
          else if (data === 'Updated Successfully!.') {
            this.service.add({ severity: 'success', summary: 'Success Message', detail: 'Password Updated Successfully.' });
            setTimeout(() => {
              this.router.navigate(['/endor-registration-login']);
            }, 2000);
          }
        },
        error: (res) => {
          console.error('Error in forgot password:', res);
          this.loader.close();
          this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! userid or password not correct.' });
          this.activityRecordService.activityRecord(this.f.email.value, 'vendfor-forgot-pass(error)', '', new Date(), res, reqBodyAfterEncypt);

        }
      });
  }

  get f() {
    return this.onAuthForm.controls;
  }

  onOTPClick() {
    if (!this.f.email.value) {
      this.service.add({ severity: 'error', summary: 'Error Message', detail: 'Email Can not be Empty.' });
      return;
    }
    this.f.otp.setValue('');
    
    let reqBody = {
      Email: this.f.email.value
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    this.loader.start();
    this.authService.generateOtpForUserForVenReg(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          let encResp = JSON.parse(resp as string);
          let data = this.cryptoJs.DecryptToken(encResp.data);
          // let val1 = JSON.parse(data['data']);

          if(data == 'OTP sent on SMS and Email Id' || data == 'OTP already sent on SMS and Email Id'){
            this.service.add({ 
              severity: 'success', 
              summary: 'Success Message', 
              detail: data.toString() 
            });

            this.disableOTPButton(3);
            this.disableUserName = true;
            this.showPasswordsSections = true;
          }else {
            this.service.add({ 
              severity: 'info', 
              summary: 'Info Message', 
              detail: data.toString() 
            });
          }    
        },
        error: (err) => {
          this.loader.close();
          this.service.add({ 
            severity: 'error', 
            summary: 'Error Message', 
            detail: `Error! OTP not generated. ${err}` });
        }
      });
  }

  disableOTPButton(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

